export const cardDataConsentContract = [
    {
        title: 'Getting Started with Consent Contracts',
        description:
            'A complete example graph that demonstrates common query patterns.',
        cta: {
            icon: 'mdi:chart-scatter-plot-hexbin',
            text: 'Open Guide',
        },
    },
    {
        title: 'Consent Contracts 101',
        description: 'Learn how to use BIQ Consent Contracts.',
        cta: {
            icon: 'mdi-console',
            text: 'Learn More',
        },
    },
];

export const cardDataReceipts = [
    {
        title: 'Getting started with Receipts',
        description:
            'The Receipt Viewer is a feature that allows you to see how smart contracts were executed',
        cta: { icon: 'mdi-arrow-right', text: 'Get Started' },
    },

    {
        title: 'Checkout the Receipt Viewer Today!',
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
        cta: {
            icon: 'mdi:chart-scatter-plot-hexbin',
            text: 'Open Guide',
        },
    },
    {
        title: 'Receipts 101',
        description: 'Learn everything you need to know about Receipts',
        cta: {
            icon: 'mdi:information-outline',
            text: 'Learn More',
        },
    },
];

export const cardDataSmartContractList = [
    {
        title: 'Getting Started With Smart Contracts',
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
        cta: {
            icon: 'mdi:chart-scatter-plot-hexbin',
            text: 'Open Guide',
        },
    },
    {
        title: 'Smart Contracts 101',
        description: 'Learn how to use BIQ Smart Contracts',
        cta: {
            icon: 'mdi:information-outline',
            text: 'Learn More',
        },
    },
];
